import { useEffect, useState } from 'react';

const fetchLocations = async () => {
  try {
    const apiEndpoint = '/careers/api/locations';
    let origin = window.location.origin;

    if (origin.includes('localhost')) {
      origin = 'https://www.klaviyo.com';
    }

    const response = await fetch(`${origin}${apiEndpoint}`);
    const parsed = await response.json();

    return parsed?.locations ?? [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

const useGreenhouseLocations = () => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    fetchLocations().then((jobLocations) => {
      if (jobLocations.length > 0) {
        setLocations(jobLocations);
      }
    });
  }, []);

  return locations;
};

export default useGreenhouseLocations;
